<template>
  <div class="FilterBoxAppAccou box-filter">
    <el-form :model="ruleForm" ref="ruleForm" @submit.prevent v-on:submit.prevent>
      <el-row type="flex" class="row-bg" justify="end">
        <el-col :xs="24" :span="5">
        </el-col>
        <el-col :xs="24" :span="4">
          <el-badge is-dot class="item" style="width: 100%" :hidden="!statusClearFilter">
            <el-button type="default" size="large" @click="viewFilter = !viewFilter" style="width: 100%">
              Mais Filtros
            </el-button>
          </el-badge>
        </el-col>
      </el-row>
      <div v-show="viewFilter" class="viewFilter">
        <el-row :gutter="20">
          <el-col :sm="12" :md="12">
            <el-form-item prop="id_status" label="ID">
              <el-input v-model="ruleForm.id_status" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12">
            <el-form-item prop="status" label="Status">
              <el-select v-model="ruleForm.status" clearable style="width: 100%;">
                <el-option value="new" label="Cadastro"/>
                <el-option value="risk_analysis" label="Processando"/>
                <el-option value="risk_analysis_manually" label="Analise Manual"/>
                <el-option value="risk_analysis_awaiting" label="Aguardando Documentação"/>
                <el-option value="risk_analysis_reproved" label="Reprovado por pendência de regularização"/>
                <el-option value="risk_analysis_error" label="Erro"/>
                <el-option value="risk_analysis_rejected" label="Reprovado por Análise de Risco"/>
                <el-option value="pending" label="Pendente"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12">
            <el-form-item prop="cpf" label="CPF">
              <el-input v-model="ruleForm.cpf" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12">
            <el-form-item prop="cnpj" label="CNPJ">
              <el-input v-model="ruleForm.cnpj" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12">
            <el-form-item prop="marketplace" label="Marketplace">
              <SelectSearchMarketplace :disabled="$can('2|4|5')" :model="ruleForm.marketplace_id" :isEdit="false" @handleValue="(x) => {$set(ruleForm, 'marketplace_id', x)}" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Itens por página">
              <el-input-number style="width: 100%" :controls="false" v-model="ruleForm.per_page" :min="0" :max="99999"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-col :xs="24" :span="15">
            <el-button  native-type="submit" @click.prevent='searchTable' type="primary" size="large" style="float: right">
              Filtrar
            </el-button>
            <el-button v-if="statusClearFilter" @click='clearSearch' type="default" size="large" style="float: right; margin-right: 20px">
              Limpar Filtros
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";

export default {
  name: "FilterBoxAppAccou",
  components: {
    SelectSearchMarketplace
  },
  data () {
    return {
      loadingPage: true,
      ruleForm: {
        per_page: 25,
      },
      viewFilter: false,
    }
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    type: {
      type: Number,
      default: 0
    }
  },
  computed: {
    statusClearFilter: function () {
      if (this.ruleForm.person_id ||
          (this.ruleForm.per_page !== 25)) {
        return true
      }
      return false
    }
  },
  methods: {
    clearSearch () {
      this.viewFilter = false
      this.ruleForm = {
        per_page: 25,
        id_status: '',
        cpf: '',
        cnpj: '',
        marketplace_id: '',
        status: '',
      }
      this.$emit('filter', `?page=${this.currentPage}`)
    },
    searchTable () {
      let query = `?page=${this.currentPage}`
      if (this.ruleForm.id_status) {
        query = `${query}&id_status=${this.ruleForm.id_status}`
      }
      if (this.ruleForm.cpf) {
        query = `${query}&cpf=${this.ruleForm.cpf}`
      }
      if (this.ruleForm.cnpj) {
        query = `${query}&cnpj=${this.ruleForm.cnpj}`
      }
      if (this.ruleForm.marketplace_id) {
        query = `${query}&marketplace_id=${this.ruleForm.marketplace_id}`
      }
      if (this.ruleForm.per_page) {
        query = `${query}&per_page=${this.ruleForm.per_page}`
      }
      if (this.ruleForm.status) {
        query = `${query}&status=${this.ruleForm.status}`
      }
      this.$emit('filter', query)
    },
  }
}
</script>

<style scoped>

</style>
